<template>
  <div class="booking-widget p-6 rounded">
    <tooltip name="ttDates" ref="ttDates">
      <template v-slot:trigger="{ toggle, isShowing }">
        <div class="flex items-center relative" :class="{ 'has-error': forceShowDatePicker }">
          <svg width="24" height="24" class="flex-none booking-widget-input-icon--left">
            <use xlink:href="/img/sprite.svg#ic_calendar"></use>
          </svg>
          <input type="text"
            tabindex="100"
            readonly
            placeholder="Select start date"
            :value="dateDisplay"
            class="cursor-pointer rounded input-tall w-full border border-black-30 booking-widget-input"
            :class="{ 'force-focus': isShowing }"
            @click="toggle" />
        </div>
      </template>

      <template v-slot:default="{ toggle }">
        <div class="px-5 pt-6 pb-6 bg-white rounded mt-2 md:rounded-none mdsm:p-0" style="right: 24px">
          <date-picker v-model="formData.date" @close="toggle" />
        </div>
      </template>
    </tooltip>

    <div class="mt-4 mb-6" :class="{ 'has-error': forceShowGuestsPicker }">
      <guest-picker
        placeholder="Add travelers"
        ref="ttGuests"
        :options="GUESTS_OPTIONS" />
    </div>

    <template v-if="hasSelectedProjects">
      <ul>
        <li v-for="(programmes, key, index) in cartItems"
          :key="index"
          class="item-row">
          <span>
            {{ programmes.length }}x
          </span>
          <span>
            {{ programmes[0].name }}
          </span>
          <span class="text-right">
            <currency-context>
              <template v-slot="{ convert }">
                <span
                  v-text="convert(getItemPrice(programmes[0]))"
                ></span>
              </template>
            </currency-context>
          </span>
        </li>
      </ul>
      <hr class="separator-slim my-4" />
      <template v-if="hasMixedSelection === false">
        <div class="fs-20">
          <div class="total-row">
            <span class="font-medium">
              Total
            </span>
            <div class="text-right">
              <currency-context>
                <template v-slot="{ convert }">
                  <span
                    class="font-medium"
                    v-text="convert(total)"
                  ></span>
                </template>
              </currency-context>
              {{ selectedCategory === 'ecoventure' ? '/week' : '/trip' }}
            </div>
          </div>
        </div>

        <button type="button"
          class="btn btn-primary w-full mt-6"
          @click="handleEnquire"
          :disabled="isSubmitting">
          Enquire
        </button>
      </template>

      <div v-else>
        <span class="text-danger">
          Please choose either Ecoventure or Expedition
        </span>
      </div>
    </template>
    <template v-else>
      Add project to continue
    </template>
  </div>
</template>

<script>
import GuestPicker from '../core/Booking/GuestPicker'
import Tooltip from '../core/Tooltip'
import DatePicker from '../core/DatePicker'
import CurrencyContext from '../core/CurrencyContext';
import {
  ECOVENTURE_CATEGORIES
} from '../../helpers/constants'
import {
  getBookingDateDisplay
} from '../../helpers'
import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    Tooltip,
    DatePicker,
    GuestPicker,
    CurrencyContext
  },
  provide () {
    return {
      formData: this.$store.state.formData
    }
  },
  data () {
    return {
      GUESTS_OPTIONS: [
        { value: '1', label: '1 traveler' },
        { value: '2', label: '2 travelers' },
        { value: '3', label: '3 travelers' },
        { value: '4', label: '4 travelers' },
        { value: '5', label: '5 travelers' },
        { value: '6', label: '6 travelers' },
        { value: '7', label: '7 travelers' },
        { value: '8', label: '8 travelers' },
        { value: '9', label: '9 travelers' },
        { value: '10+', label: 'More than 10 travelers' }
      ]
    }
  },
  computed: {
    ...mapState([
      'selectedProgrammes',
      'formData',
      'forceShowDatePicker',
      'forceShowGuestsPicker',
      'isSubmitting'
    ]),
    ...mapGetters(['cartItems']),
    hasSelectedProjects () {
      return Boolean(this.selectedProgrammes.length)
    },
    dateDisplay () {
      return getBookingDateDisplay(this.formData.date, null)
    },
    total () {
      return this.selectedProgrammes.reduce((agg, programme) => {
        return agg + this.getItemPrice(programme)
      }, 0)
    },
    selectedCategory () {
      return this.selectedProgrammes[0].category
    },
    hasMixedSelection () {
      const numEcoventures = this.selectedProgrammes.filter(pg => {
        return pg.category === ECOVENTURE_CATEGORIES.ECOVENTURE
      })

      const numExpeditions = this.selectedProgrammes.filter(pg => {
        return pg.category === ECOVENTURE_CATEGORIES.EXPEDITION
      })

      if (numEcoventures.length !== 0 && numExpeditions.length !== 0) {
        return true
      }

      return false
    }
  },
  methods: {
    getItemPrice (item) {
      if (item.category === ECOVENTURE_CATEGORIES.ECOVENTURE) {
        return item.eco_weekly_price
      }
      else if (item.category === ECOVENTURE_CATEGORIES.EXPEDITION) {
        return item.expedition_price
      }

      return 0
    },
    handleEnquire () {
      this.$store.dispatch('doEnquire')
    }
  }
}
</script>

<style scoped>
.item-row {
  display: grid;
  grid-template-columns: 32px auto 100px;
}

.total-row {
  display: grid;
  grid-template-columns: auto 100px;
}

.has-error ::v-deep .guest-picker input {
  border-color: red;
}

.has-error ::v-deep .booking-widget-input {
  border-color: red;
}
</style>
